<template>
  <div class="container">
    <!-- SEARCH -->
    <div class="card my-2">
      <div class="card-body">
        <div>
          <div class="flex-fill">
            Organization Name
            <b-form-input v-model="query.organization_name" class="p-2" placeholder="Enter organization name"></b-form-input>
          </div>
        </div>
        <div class="my-1">
          <b-form-group label="Missing Location Information">
            <b-form-checkbox-group v-model="query.missing">
              <b-form-checkbox value="city">City</b-form-checkbox>
              <b-form-checkbox value="state">State</b-form-checkbox>
              <b-form-checkbox value="country">Country</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div class="my-1">
          <b-form-group label="Missing Contact Information">
            <b-form-checkbox-group v-model="query.missing">
              <b-form-checkbox value="website">Website</b-form-checkbox>
              <b-form-checkbox value="logo">Logo</b-form-checkbox>
              <b-form-checkbox value="email">Email</b-form-checkbox>
              <b-form-checkbox value="phone">Phone Number</b-form-checkbox>
              <b-form-checkbox value="linkedin">LinkedIn</b-form-checkbox>
              <b-form-checkbox value="twitter">Twitter</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
      <div class="p-3 d-flex justify-content-center">
        <a @click="setResources" class="btn btn-danger btn-sm m-1" style="color: #FFFFFF">Search</a>
        <a @click="resetSearch" class="btn btn-dark btn-sm m-1" style="color: #FFFFFF">Reset</a>
      </div>
    </div>
    <div v-if="resources !== null">
      <div class="card my-2">
        <div class="card-body">
          <div class="d-flex align-items-center" style="font-size: 0.9em;">
            <div>
              <span style="font-weight: 300">FOUND</span> {{ resources.objects.length }} <span style="font-weight: 300">RESULTS</span>
            </div>
            <div class="ml-auto d-flex align-items-center">
              ORDER BY
              <div class="mx-1">
                <b-form-select size="sm" v-model="query.order_field" :options="orderField" @change="setResources"></b-form-select>
              </div>
              <div class="mx-1">
                <b-form-select size="sm" v-model="query.order_direction" :options="orderDirection" @change="setResources"></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <single-resource v-bind:resource="resource" v-for="resource in resources.objects" :key="resource.id"/>
    </div>
  </div>
</template>

<script>
import startupResourcesAPI from '../../api/startupResources'
import SingleResource from './SingleResource'
export default {
  name: '',
  components: {SingleResource},
  data: function () {
    return {
      resources: null,
      query: {},
      isLoading: false,
      orderField: [
        {
          text: 'Resource Name', value: 'name'
        },
        {
          text: 'Last Updated', value: 'last_updated'
        },
        {
          text: 'When Created', value: 'when_created'
        }
      ],
      orderDirection: [
        {
          text: 'Ascending', value: 0
        },
        {
          text: 'Descending', value: 1
        }
      ]
    }
  },
  methods: {
    resetQuery () {
      this.query = {
        order_field: 'name',
        order_direction: 0
      }
    },
    resetSearch () {
      this.resetQuery()
      this.setResources()
    },
    setResources () {
      this.$store.commit('setIsLoading', true)
      startupResourcesAPI.getStartupResources(this.query).then(
        response => {
          this.resources = response.data.data
          this.$store.commit('setIsLoading', false)
        }
      )
    }
  },
  created() {
    this.resetSearch()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/startupResources/Index.vue